import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Varchar,
  Char,
  Text,
  Int,
  DateInput,
  TimeInput,
  DateTimeInput,
  Decimal,
  Bool,
  DataEmail,
  DataPhone,
  Label,
} from "../inputs";
import { faUmbrella } from "@fortawesome/free-solid-svg-icons";
import { LoadingIcon } from "../../Icons/loading.icon";

export default function COMPONENT({ isData = {},buttonId }) {
  const { isModal, urlData, idStr, handleCloseModal } = isData;
  const dispatch = useDispatch();
  const { id_str } = useParams();
  const _token = localStorage.getItem("_token");
  const { project_id, version_id, url } = useParams();
  let navigate = useNavigate();
  const { proxy, pages, lang, socket, functions } = useSelector(
    (state) => state
  );
  const [api, setApi] = useState({});
  const [tables, setTables] = useState([]);
  const [keyFields, setKeyFields] = useState([]);
  const [params, setParams] = useState([]);
  const [fields, setFields] = useState([]);
  const [data, setData] = useState({});
  const [relatedTables, setRelatedTables] = useState([]);
  const [initialData, setInitData] = useState({});
  const [loaded, setLoaded] = useState(true);
  const [page, setPage] = useState([]);
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("myParam");

  const goToHomePage = () => {
    // navigate(`/page/${url}`);
    navigate(-1);
  };

  useEffect(() => {
    if (pages && pages.length > 0) {
      const result = functions.findPageById(pages, `${url}`);
      if (result?.component.length > 0) {
        setPage(result);
      } else {
      }
    }
  }, [pages, url, idStr, urlData]);

  const result = functions.findPutApi(page);

  const configDetail = functions.findDetailApi(page);
  console.log(configDetail);
  // thinh viet lai ham render du lieu apiFields
  useEffect(() => {
    const checkIdStr = id_str ? id_str : idStr;
    const url = window.location;
    const rawParams = url.pathname.split(`/${id_str}/`)[1];
    const rawUrl = urlData?.split(`/${checkIdStr}/`)[1];
    const checkRawParams = rawParams ? rawParams : rawUrl;
    const paramsList = checkRawParams?.split("/");
    console.log("checkIdStr", checkIdStr)
    // console.log(rawParams)
    fetch(`${proxy()}/apis/api/${checkIdStr}/input_info`, {
      headers: {
        Authorization: _token,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, data } = res;
        const currentPage = pages.find(
          (p) =>
            p.block ===
            result?.component?.find(
              (item) => item?.props?.buttons?.add?.api?.api_id === checkIdStr
            )?.id
        )?.component?.[0]?.children;
        if (success) {
          // const { tables } = data.tables;
          const apiFields = data.body;

          // apiFields.push(...data.body);

          const serializeParams = apiFields.map((param, index) => {
            const { fomular_alias } = param;
            return { fomular_alias, value: paramsList?.[index] };
          });

          const keyFields = serializeParams.map((par) => {
            const field = apiFields.filter(
              (f) => f.fomular_alias == par.fomular_alias
            )[0];
            return field;
          });

          setKeyFields(keyFields);
          setParams(serializeParams);
          setApi(data);

          setFields(apiFields);
          setTables(data.tables);
          setRelatedTables(relatedTables);
          // fetch(`${proxy()}/apis/retrieve/${id_str}/${rawParams}`, {
          fetch(`${proxy()}/apis/retrieve/${checkIdStr}/${checkRawParams}`, {
            headers: {
              Authorization: _token,
            },
          })
            .then((res) => res.json())
            .then((res) => {
              // console.log(res);

              const { data, success } = res;
              if (success) {
                let initData = data;

                if (initData[0]) {
                  const data = {};
                  apiFields.map((field) => {
                    const { fomular_alias } = field;
                    data[fomular_alias] = initData[0][fomular_alias];
                  });
                  setInitData(initData[0] ? initData[0] : {});
                  setData({ ...data });
                  setLoaded(false);
                }
              }
            });
        } else {
          // al.failure("Lỗi", "API này không tồn tại hoặc đã bị vô hiệu")
        }
      });
  }, [idStr, urlData]);
  if (loaded) {
    return (
      <img
        width={40}
        className="loading-image"
        src="/images/icon/load.gif"
        alt="Loading..."
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}
      />
      // <div
      //   style={{
      //     width: "50px",
      //     margin: "auto",
      //   }}
      // >
      //   <LoadingIcon />
      // </div>
    );
  }
  return (
    <div class="midde_cont">
      <div class="container-fluid">
        {!isModal ? (
          <>
            <div class="row column_title">
              <div class="col-md-12">
                <div class="page_title">
                  <h4 class="ml-1">{lang["data management"]}</h4>
                </div>
              </div>
            </div>
            {/* List table */}
            <div class="row">
              <div class="col-md-12">
                <div class="white_shd full margin_bottom_30">
                  <div class="full graph_head_cus d-flex">
                    <div class="heading1_cus margin_0 ">
                      {/* <h5> <a onClick={() => navigate(-1)}><i class="fa fa-chevron-circle-left mr-3"></i></a>{page?.components?.[0]?.component_name}</h5> */}
                      <h5>
                        <label class="pointer" onClick={() => goToHomePage()}>
                          <a title={lang["back"]}>
                            <i class=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link"></i>
                          </a>
                          {functions.findPropsNameDetailByUrl(page, id_str)}
                          {/* {result?.title} */}

                          <i
                            class={` ${
                              functions
                                .findPropsNameDetailByUrl(page, id_str)
                                ?.trim() !== "" &&
                              "fa fa-chevron-right ml-2 mr-1"
                            } `}
                          ></i>
                          {lang["viewdetail"]}
                        </label>
                      </h5>
                    </div>
                    {/* <div class="ml-auto">
                             <i class="fa fa-newspaper-o icon-ui"></i>
                         </div> */}
                  </div>
                  <div class="table_section padding_infor_info">
                    <div class="row column1">
                      {tables.length > 0 ? (
                        <div class="col-md-12">
                          <div className="w-50-pct mg-auto p-1 bg-white">
                            <span className="block text-32-px text-center p-0-5">
                              {api.api_name}
                            </span>
                            {/* thinh this is where i need to fix */}
                            <div className="label-container">
                              {fields.map((field) => (
                                <div key={field.field_id}>
                                  {field.DATATYPE == "PHONE" ||
                                  field.DATATYPE == "TEXT" ||
                                  field.DATATYPE == "CHAR" ||
                                  field.DATATYPE == "INT" ||
                                  field.DATATYPE == "EMAIL" ||
                                  field.data_type == "BIG INT" ||
                                  field.DATATYPE == "INT UNSIGNED" ||
                                  field.data_type == "BIG INT UNSIGNED" ||
                                  field.DATATYPE == "DATE" ||
                                  field.DATATYPE == "TIME" ||
                                  field.DATATYPE == "DATETIME" ||
                                  field.DATATYPE == "DECIMAL" ||
                                  field.DATATYPE == "DECIMAL UNSIGNED" ||
                                  field.DATATYPE == "BOOL" ||
                                  field.DATATYPE == "FILE" ? (
                                    <Label
                                      selectOption={false}
                                      table={
                                        tables?.filter(
                                          (tb) => tb.id == field.table_id
                                        )[0]
                                      }
                                      related={relatedTables}
                                      field={field}
                                      defaultValue={
                                        initialData[field.fomular_alias]
                                      }
                                    />
                                  ) : null}
                                </div>
                              ))}
                            </div>
                            <div class="row justify-content-center">
                              <div class="col-md-6">
                                <div class="mt-2 d-flex justify-content-end"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {" "}
            <div class="table_section padding_infor_info">
              <div class="row column1">
                {tables.length > 0 ? (
                  <div class="col-md-12">
                    <div className="w-50-pct mg-auto p-1 bg-white">
                      <span className="block text-32-px text-center p-0-5">
                        {api.api_name}
                      </span>
                      {/* thinh this is where i need to fix */}
                      <div className="label-container">
                        {fields.map((field) => (
                          <div key={field.field_id}>
                            {field.DATATYPE == "PHONE" ||
                            field.DATATYPE == "TEXT" ||
                            field.DATATYPE == "CHAR" ||
                            field.DATATYPE == "INT" ||
                            field.DATATYPE == "EMAIL" ||
                            field.data_type == "BIG INT" ||
                            field.DATATYPE == "INT UNSIGNED" ||
                            field.data_type == "BIG INT UNSIGNED" ||
                            field.DATATYPE == "DATE" ||
                            field.DATATYPE == "TIME" ||
                            field.DATATYPE == "DATETIME" ||
                            field.DATATYPE == "DECIMAL" ||
                            field.DATATYPE == "DECIMAL UNSIGNED" ||
                            field.DATATYPE == "BOOL" ||
                            field.DATATYPE == "FILE" ? (
                              <Label
                                selectOption={false}
                                table={
                                  tables?.filter(
                                    (tb) => tb.id == field.table_id
                                  )[0]
                                }
                                related={relatedTables}
                                field={field}
                                defaultValue={initialData[field.fomular_alias]}
                              />
                            ) : null}
                          </div>
                        ))}
                      </div>
                      <div class="row justify-content-center">
                        <div class="col-md-6">
                          <div class="mt-2 d-flex justify-content-end">
                            {/* <button type="button" style={{ minWidth: "105px" }} onClick={() => goToHomePage()} data-dismiss="modal" class="btn btn-danger">{lang["btn.close"]}</button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
